import React from "react";
import ReactTooltip from "react-tooltip";

import { InfoIconSvg } from "../../../../assets/Icons";

import ToggleButton from "./toggleButton";

import { ActivitySectionStyles } from "./activitySection.styles";
import { useTranslation } from "react-i18next";

const ActivitySection = ({ onToggle }) => {
  const { t } = useTranslation();

  return (
    <ActivitySectionStyles>
      <ToggleButton onToggle={onToggle} />
      <a data-tip data-for="sadFace" style={{ cursor: "pointer" }}>
        <InfoIconSvg />
      </a>
      <ReactTooltip
        id="sadFace"
        place="top"
        effect="solid"
        className="tooltip"
        backgroundColor="#1568bf"
        borderColor="#1568bf"
        arrowColor="#1568bf"
      >
        <span className="spanText">{t("disable_benefit_warning")}</span>
      </ReactTooltip>
    </ActivitySectionStyles>
  );
};

export default ActivitySection;
